export default {
  SET_SELECTED_ELEMENT_FOR_COMMENTS(state, payload) {
    state.selectedElementForComment = payload
  },
  SET_SELECTED_EDGE_FOR_LABELS(state, payload) {
    state.selectedEdgeForLabel = payload
  },
}
